import {
  EmailField,
  InputText,
  PhoneNumberField,
  AddressInput,
} from "../../components";
import { useFormContext } from "react-hook-form";
import { AddressDetails } from "../../components/AddressInput";

function CustomerDetails() {
  const { control, setValue } = useFormContext();

  return (
    <div className="space-y-3">
      <InputText
        control={control}
        name="customerDetails.name"
        required
        label="Name on invoice"
      />
      <EmailField
        control={control}
        name="customerDetails.email"
        required
        label="Email"
      />
      <PhoneNumberField
        control={control}
        name="customerDetails.phone"
        required
        label="Phone"
      />
      <AddressInput
        control={control}
        name="customerDetails.address"
        onAddressSelect={(address: AddressDetails) => {
          setValue("customerDetails.city", address.city);
          setValue("customerDetails.state", address.state);
          setValue("customerDetails.zip_code", address.zipCode);
        }}
        label="Address"
        required
      />
      <InputText
        control={control}
        name={"customerDetails.city"}
        required
        label="City"
      />
      <InputText
        control={control}
        name={"customerDetails.state"}
        required
        label="State"
      />
      <InputText
        control={control}
        name={"customerDetails.zip_code"}
        required
        label="Zip code"
      />
    </div>
  );
}

export default CustomerDetails;
